import {
    fetch_soap_notes, update_drug_mask,
    save_med_doctor_info,
    add_medications,
    pharmacy_soapnotes_pdf,
    update_drug_reasons,
    med_rephrase_drp,
    med_special_instructions,
    med_special_instructions_rephrase,
    translate_special_instructions,
    update_special_instructions,
    pharmacy_save_med_review,
    create_soap_notes,
    pharmacy_generate_soap_notes,
    pharmacy_save_soap_notes,
    pharmacy_fetch_doctors_from_winrx,
    pharmacy_fax_soap_note,
    pharmacy_send_log_fax,
    pharmacy_download_medication_history,
    pharmacy_bpmh_fax_send,
    pharmacy_save_drp_identified
} from "../../../../networking/urlEndPoints";
import { toast } from "react-toastify";

import { FetchAllDoctorsList } from "../../../actions/pharmacy/doctors/doctorsList";
import { DownLoadPDF, PreviewPdf, showToast } from "../../../../utils/helper/helper";
import { confirmSendFax } from "../../../../utils/helper/faxConfirmation";
import { isNonEmptyText } from "../../../../utils/helper/toText";

import Axios from "../../../../networking/intraceptor";

const FETCH_PATIENT_SOAP_LIST_REQUEST = 'FETCH_PATIENT_SOAP_LIST_REQUEST';
const FETCH_PATIENT_SOAP_LIST_SUCCESS = 'FETCH_PATIENT_SOAP_LIST_SUCCESS';
const FETCH_PATIENT_SOAP_LIST_FAILURE = 'FETCH_PATIENT_SOAP_LIST_FAILURE';

const ADD_PATIENT_SOAP_NOTE_DATA_REQUEST = 'ADD_PATIENT_SOAP_NOTE_DATA_REQUEST';
const ADD_PATIENT_SOAP_NOTE_DATA_SUCCESS = 'ADD_PATIENT_SOAP_NOTE_DATA_SUCCESS';
const ADD_PATIENT_SOAP_NOTE_DATA_FAILURE = 'ADD_PATIENT_SOAP_NOTE_DATA_FAILURE';

const UPDATE_DRP_IDENTIFIED_REQUEST = 'UPDATE_DRP_IDENTIFIED_REQUEST';
const UPDATE_DRP_IDENTIFIED_SUCCESS = 'UPDATE_DRP_IDENTIFIED_SUCCESS';
const UPDATE_DRP_IDENTIFIED_FAILURE = 'UPDATE_DRP_IDENTIFIED_FAILURE';

const FETCH_SOAP_NOTES_REQUEST = 'FETCH_SOAP_NOTES_REQUEST';
const FETCH_SOAP_NOTES_SUCCESS = 'FETCH_SOAP_NOTES_SUCCESS';
const FETCH_SOAP_NOTES_FAILURE = 'FETCH_SOAP_NOTES_FAILURE';

//PATIENT SOAP NOTES 
export const patientSoapNotesRequest = (requestType) => ({
    type: FETCH_PATIENT_SOAP_LIST_REQUEST,
    payload: { requestType },
});

export const patientSoapNotesSuccess = (data, requestType) => ({
    type: FETCH_PATIENT_SOAP_LIST_SUCCESS,
    payload: { data, requestType },
});

export const patientSoapNotesFailure = (error, requestType) => ({
    type: FETCH_PATIENT_SOAP_LIST_FAILURE,
    payload: { error, requestType },
});

export const FetchPatientSoapNotes = ({ reqData, requestType }) => {
    return async (dispatch) => {
        dispatch(patientSoapNotesRequest(requestType));
        try {
            const response = await Axios.post(fetch_soap_notes, reqData);
            if (response.status === 200) {
                dispatch(patientSoapNotesSuccess(response.data, requestType));
            }
        } catch (error) {
            const errorMessage = error?.response;
            dispatch(patientSoapNotesFailure(errorMessage, requestType));
        }
    };
};
//PATIENT SOAP NOTES 

//Update Drug Mask
export const HandleUpdateDrugMask = ({ reqData }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post(update_drug_mask, reqData);
            if (response.status === 200) {
                toast.success('updated successfully.');
            }
        } catch (error) {
            toast.error('Failed to update, retry');
        }
    };
};
//Update Drug Mask


//Add data
export const addPatientSoapNotesDataRequest = (requestType) => ({
    type: ADD_PATIENT_SOAP_NOTE_DATA_REQUEST,
    payload: { requestType },
});

export const addPatientSoapNotesDataSuccess = (data, requestType) => ({
    type: ADD_PATIENT_SOAP_NOTE_DATA_SUCCESS,
    payload: { data, requestType },
});

export const addPatientSoapNotesDataFailure = (error, requestType) => ({
    type: ADD_PATIENT_SOAP_NOTE_DATA_FAILURE,
    payload: { error, requestType },
});
//Add data

//Update Doctor
export const HandleUpdate_doctor = ({ reqData, requestType, setShowModal, fetchListReq, fetchFromPharmanet, lastGenerated }) => {
    return async (dispatch, getState) => {
        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(save_med_doctor_info, reqData);
            if (response.status === 200) {
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType));
                if (reqData.doctor_option === 'auto') {
                    if (typeof setShowModal === 'function') {
                        setShowModal((prevStat) => ({ ...prevStat, update_doctor: false }))
                        // Restore body overflow after closing modal
                        document.body.style.overflow = 'auto';
                    }
                    // Existing behaviour (refetch entire list after updating doctor) – kept for reference
                    // if (fetchListReq.phn) {
                    //     if (fetchFromPharmanet) {
                    //         fetchListReq.fetch_from_pharmanet = 1
                    //     }
                    //     if (lastGenerated) {
                    //         fetchListReq.last_generated = 1
                    //     }
                    //     dispatch(FetchPatientSoapNotes({ reqData: fetchListReq, requestType: 'patient-soap-notes' }))
                    // }

                    // New behaviour: update doctor details directly in existing Redux state without refetch
                    try {
                        const fullDoctorText = response?.data?.data; // e.g. "PALVINDER SANDHU (00QNW)"
                        const rxid = reqData?.rxid;

                        // Parse "FIRST LAST (CODE)" into parts used by UI {dr1st} {drlast} ({rxdea})
                        let dr1st = '';
                        let drlast = '';
                        let rxdea = '';

                        if (typeof fullDoctorText === 'string') {
                            const match = fullDoctorText.match(/^(.*)\s+\(([^)]+)\)$/);
                            if (match) {
                                const namePart = match[1]?.trim();      // "PALVINDER SANDHU"
                                rxdea = match[2]?.trim();               // "00QNW"

                                const nameTokens = namePart.split(' ').filter(Boolean);
                                if (nameTokens.length > 1) {
                                    drlast = nameTokens.pop();          // "SANDHU"
                                    dr1st = nameTokens.join(' ');       // "PALVINDER"
                                } else {
                                    dr1st = namePart;
                                }
                            } else {
                                dr1st = fullDoctorText;
                            }
                        }

                        const state = getState();
                        const soapState = state?.patientSoapNotes?.patientSoapNotesData;
                        const currentPayload = soapState?.data;

                        if (currentPayload?.data) {
                            const currentData = currentPayload.data;

                            const updateDoctorForList = (list) =>
                                list?.map((item) =>
                                    item.id === rxid
                                        ? {
                                            ...item,
                                            dr1st: dr1st || item.dr1st,
                                            drlast: drlast || item.drlast,
                                            rxdea: rxdea || item.rxdea,
                                        }
                                        : item
                                );

                            const updatedPayload = {
                                ...currentPayload,
                                data: {
                                    ...currentData,
                                    patientdatafinaldata: updateDoctorForList(currentData.patientdatafinaldata),
                                    patientinactivefinaldata: updateDoctorForList(currentData.patientinactivefinaldata),
                                },
                            };

                            dispatch(patientSoapNotesSuccess(updatedPayload, 'patient-soap-notes'));
                        }
                    } catch (updateError) {
                        // If anything goes wrong while updating local state, just show a warning
                        console.error('Error updating doctor in local state', updateError);
                    }

                    showToast("Updated Successfully.", "success")
                } else {
                    showToast("Doctor Added Successfully.", "success")
                    dispatch(FetchAllDoctorsList())
                }
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Got an issue while updating doctor.please try again", "error")
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};
//Update Doctor

//ADD MEDICATIONS
export const HandleAdd_medications = ({ reqData,
    requestType,
    setShowModal,
    patientActiveMedicationsIds,
    patientInactiveMedicationsIds,
    pharmacyId,
    patientPhn,
    fetchFromPharmanet, lastGenerated }) => {

    return async (dispatch) => {
        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(add_medications, reqData);
            if (response.status === 200) {
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType));
                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, add_medications: false }))
                    // Restore body overflow after closing modal
                    document.body.style.overflow = 'auto';
                }
                const idsFromResponse = response?.data?.data?.map((value) => value?.id).filter((id) => id !== undefined);
                const activeMedicationId = [patientActiveMedicationsIds, ...idsFromResponse].flat()

                if (patientPhn) {
                    const fetchListReq = {
                        pharmacy_id: pharmacyId,
                        phn: patientPhn,
                        activerx: activeMedicationId,
                        inactiverx: patientInactiveMedicationsIds
                    }
                    if (fetchFromPharmanet) {
                        fetchListReq.fetch_from_pharmanet = 1
                    }
                    if (lastGenerated) {
                        fetchListReq.last_generated = 1
                    }
                    dispatch(FetchPatientSoapNotes({ reqData: fetchListReq, requestType: 'patient-soap-notes' }))
                }
                showToast("Medications Added Successfully.", "success")
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Error adding medication details. Please try again.", "error")
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};

//BULK MOVE/DELETE MEDICATIONS - Frontend-only update (no API call, no refetch)
// Same pattern as single medication delete - updates Redux state directly
export const HandleBulkMoveMedications = ({ reqData, requestType, operationType, selectedIds }) => {
    return async (dispatch, getState) => {
        try {
            // Update Redux state directly without making API call (same as single delete)
            const state = getState();
            const soapState = state?.patientSoapNotes?.patientSoapNotesData;
            const currentPayload = soapState?.data;

            if (!currentPayload?.data) {
                showToast('No patient data available.', 'error');
                return;
            }

            const currentData = currentPayload.data;
            let updatedActiveList = [...(currentData.patientdatafinaldata || [])];
            let updatedInactiveList = [...(currentData.patientinactivefinaldata || [])];

            if (operationType === 'inactive') {
                // Move from active to inactive
                const medicationsToMove = updatedActiveList.filter(med => selectedIds.includes(med.id));
                updatedActiveList = updatedActiveList.filter(med => !selectedIds.includes(med.id));
                updatedInactiveList = [...updatedInactiveList, ...medicationsToMove];
            } else if (operationType === 'active') {
                // Move from inactive to active
                const medicationsToMove = updatedInactiveList.filter(med => selectedIds.includes(med.id));
                updatedInactiveList = updatedInactiveList.filter(med => !selectedIds.includes(med.id));
                updatedActiveList = [...updatedActiveList, ...medicationsToMove];
            } else if (operationType === 'delete_active') {
                // Delete from active
                updatedActiveList = updatedActiveList.filter(med => !selectedIds.includes(med.id));
            } else if (operationType === 'delete_inactive') {
                // Delete from inactive
                updatedInactiveList = updatedInactiveList.filter(med => !selectedIds.includes(med.id));
            }

            const updatedPayload = {
                ...currentPayload,
                data: {
                    ...currentData,
                    patientdatafinaldata: updatedActiveList,
                    patientinactivefinaldata: updatedInactiveList,
                },
            };

            dispatch(patientSoapNotesSuccess(updatedPayload, 'patient-soap-notes'));
            
            // Show success message
            const operationMessages = {
                'inactive': 'Medications moved to inactive successfully.',
                'active': 'Medications moved to active successfully.',
                'delete_active': 'Active medications deleted successfully.',
                'delete_inactive': 'Inactive medications deleted successfully.'
            };
            showToast(operationMessages[operationType] || 'Operation completed successfully.', 'success');
        } catch (error) {
            console.error('Error updating medications in local state', error);
            showToast('Failed to complete operation. Please try again.', 'error');
        }
    };
};
//ADD MEDICATIONS


//MED PREVIEW PDF
export const handleMedPreviewPdf = ({ reqData,
    requestType,
    patientID }) => {

    return async (dispatch) => {
        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(`${pharmacy_soapnotes_pdf}/${patientID}`, reqData);
            if (response.status === 200) {
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType))
                // DownLoadPDF(response?.data?.data?.base64_pdf, 'med-preview')
                PreviewPdf(response?.data?.data?.base64_pdf)
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Got an issue while Genrating PDF.please try again", "error")
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};
//MED PREVIEW PDF

//Save Med Reviews
export const handleSaveMedReviews = ({ reqData,
    requestType,
    setShowModal,
    showModal,
}) => {

    return async (dispatch) => {
        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(`${pharmacy_save_med_review}`, reqData);
            if (response.status === 200) {
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType))
                // Download PDF
                DownLoadPDF(response?.data?.pdf_data, 'med-preview')
                // Close the save confirmation modal
                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, save_med_reviews: false }))
                    // Restore body overflow after closing modal
                    document.body.style.overflow = 'auto';
                }
                // Open the URL modal to show the signing link
                if (typeof setShowModal === 'function' && response?.data?.token) {
                    setShowModal((prevStat) => ({ ...prevStat, show_sign_url_modal: true }))
                }
                showToast("Saved Successfully.", "success")
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Got an issue while saving med reviews.please try again", "error")
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};

//Save Med Reviews
export const handleDownloadMedicationHistory = ({ reqData,
    requestType,
    patientId
}) => {

    return async (dispatch) => {
        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(`${pharmacy_download_medication_history}/${patientId}`, reqData);
            if (response.status === 200) {
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType))
                PreviewPdf(response?.data?.data?.base64_pdf)
                // console.log(response?.data?.data)
                // console.log(response?.data)
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Got an issue while downloading medication history.please try again", "error")
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};

//Download BPMH PDF
export const handleDownloadBPMH_PDF = ({ reqData,
    requestType,
    pdfUrl
}) => {

    return async (dispatch) => {
        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(pdfUrl, reqData);
            if (response.status === 200) {
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType))
                PreviewPdf(response?.data?.data)
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Got an issue while downloading medication history.please try again", "error")
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};

//BPMH Fax Send 
export const handleBPMHFaxSend = ({ reqData,
    requestType,
    patientId,
    setMedPreviewPdf
}) => {

    return async (dispatch) => {
        const isConfirmed = await confirmSendFax();
        if (!isConfirmed) return;

        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(`${pharmacy_bpmh_fax_send}/${patientId}`, reqData);
            if (response.status === 200) {
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType))
                setMedPreviewPdf(false)
                showToast("Fax sent successfully", "success")
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Got an issue while sending fax.please try again", "error")
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};


//MED PREVIEW PDF
export const handleUpdateAndCreateReason = ({ reqData,
    requestType,
    onSuccess
}) => {
    return async (dispatch) => {
        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(`${update_drug_reasons}`, reqData);
            if (response.status === 200) {
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType))
                // Call onSuccess callback with response data if provided
                if (onSuccess && typeof onSuccess === 'function') {
                    onSuccess(response.data);
                }
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};

//Update DRP Identified
export const updateDRPIdentifiedRequest = (requestType) => ({
    type: UPDATE_DRP_IDENTIFIED_REQUEST,
    payload: { requestType },
});

export const updateDRPIdentifiedSuccess = (data, requestType) => ({
    type: UPDATE_DRP_IDENTIFIED_SUCCESS,
    payload: { data, requestType },
});

export const updateDRPIdentifiedFailure = (error, requestType) => ({
    type: UPDATE_DRP_IDENTIFIED_FAILURE,
    payload: { error, requestType },
});
//Update DRP Identified

//Update DRP Identified

export const handleUpdateDRPIdentified = ({ reqData,
    requestType,
    setDrpValues,
    setDrpLoading
}) => {
    return async (dispatch) => {
        dispatch(updateDRPIdentifiedRequest(requestType));
        setDrpLoading(true)
        try {
            const response = await Axios.post(`${med_rephrase_drp}`, reqData);
            if (response.status === 200) {
                dispatch(updateDRPIdentifiedSuccess(response.data, requestType))
                const rephrasedText = response?.data?.data?.rephrased_text

                // Only text goes into the box; otherwise keep what the pharmacist typed.
                if (isNonEmptyText(rephrasedText)) {
                    setDrpValues((prevValues) => ({
                        ...prevValues,
                        [`${reqData.rxid}_${reqData.patient_id}`]: rephrasedText
                    }))
                } else {
                    showToast("AI couldn't rephrase the DRP, try again.", "error")
                }
                setDrpLoading(false)
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Error while rephrasing DRP. Please try again.", "error")
            dispatch(updateDRPIdentifiedFailure(errorMessage, requestType));
            setDrpLoading(false)
        }
    };
};


//Save DRP Identified

export const handleSaveDRPIdentified = ({ reqData }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post(`${pharmacy_save_drp_identified}`, reqData);
            if (response.status === 200) {
                // console.log(response.data)
            }
        } catch (error) {
            showToast("Error while saving DRP. Please try again.", "error")
        }
    };
};


export const handleAddSpecialInstructions = ({ reqData,
    requestType,
    setSpecialInstructions,
    setSpecialInstructionsLoading
}) => {
    return async (dispatch) => {
        dispatch(updateDRPIdentifiedRequest(requestType));
        setSpecialInstructionsLoading(true)
        try {
            const response = await Axios.post(`${med_special_instructions}`, reqData);
            if (response.status === 200) {
                dispatch(updateDRPIdentifiedSuccess(response.data, requestType))
                const rephrasedText = response?.data?.instruction
                // Only text goes into the box (the AI reply can be `false`); otherwise keep the old text.
                if (isNonEmptyText(rephrasedText)) {
                    setSpecialInstructions((prevValues) => ({
                        ...prevValues,
                        [`${reqData.rxid}_${reqData.patient_id}`]: rephrasedText
                    }))
                } else {
                    showToast("AI couldn't generate instructions, try again.", "error")
                }
                setSpecialInstructionsLoading(false)
            }
        } catch (error) {
            showToast(error?.response?.data?.error || "Error while generating special instructions. Please try again.", "error")
            setSpecialInstructionsLoading(false)
        }
    };
};


export const handleSpecialInstructionsRephrase = ({ reqData,
    requestType,
    setSpecialInstructions,
    setSpecialInstructionsRephraseLoading
}) => {
    return async (dispatch) => {
        try {
            setSpecialInstructionsRephraseLoading(true)
            const response = await Axios.post(`${med_special_instructions_rephrase}`, reqData);
            if (response.status === 200) {
                dispatch(updateDRPIdentifiedSuccess(response.data, requestType))
                const rephrasedText = response?.data?.data?.rephrased_text

                // Only text goes into the box; otherwise keep the old text.
                if (isNonEmptyText(rephrasedText)) {
                    setSpecialInstructions((prevValues) => ({
                        ...prevValues,
                        [`${reqData.rxid}_${reqData.patient_id}`]: rephrasedText
                    }))
                } else {
                    showToast("AI couldn't rewrite the instructions, try again.", "error")
                }
                setSpecialInstructionsRephraseLoading(false)
            }
        } catch (error) {
            // showToast("Error while generating special instructions. Please try again.", "error")
            alert('Error while generating special instructions. Please try again.')
            setSpecialInstructionsRephraseLoading(false)
        }
    };
};

// Adds a translation below the English special instructions (the server
// saves the combined text to the prescription).
export const handleSpecialInstructionsTranslate = ({ reqData,
    setSpecialInstructions,
    setSpecialInstructionsTranslateLoading
}) => {
    return async () => {
        try {
            setSpecialInstructionsTranslateLoading(true)
            const response = await Axios.post(`${translate_special_instructions}`, reqData);
            const translated = response?.data?.data?.special_instructions
            if (response.status === 200 && translated) {
                setSpecialInstructions((prevValues) => ({
                    ...prevValues,
                    [`${reqData.rxid}_${reqData.patient_id}`]: translated
                }))
            } else {
                showToast("Could not translate. Please try again.", "error")
            }
        } catch (error) {
            showToast(error?.response?.data?.message || "Could not translate. Please try again.", "error")
        } finally {
            setSpecialInstructionsTranslateLoading(false)
        }
    };
};

export const handleUpdateSpecialInstructions = ({ reqData
}) => {

    return async (dispatch) => {
        try {
            const response = await Axios.post(`${update_special_instructions}`, reqData);
            if (response.status === 200) {

            }
        } catch (error) {
            showToast("Error while updating special instructions. Please try again.", "error")
        }
    };
};

const fetchSoapNotesRequest = (requestType) => ({
    type: FETCH_SOAP_NOTES_REQUEST,
    payload: { requestType },
});

const fetchSoapNotesSuccess = (data, requestType) => ({
    type: FETCH_SOAP_NOTES_SUCCESS,
    payload: { data, requestType },
});

const fetchSoapNotesFailure = (error, requestType) => ({
    type: FETCH_SOAP_NOTES_FAILURE,
    payload: { error, requestType },
});

export const FetchSoapNotes = ({ reqData, requestType }) => {
    return async (dispatch) => {
        dispatch(fetchSoapNotesRequest(requestType));
        try {
            const response = await Axios.get(create_soap_notes, { params: reqData });
            if (response.status === 200) {
                dispatch(fetchSoapNotesSuccess(response.data, requestType));
            }
        } catch (error) {
            const errorMessage = error?.response;
            dispatch(fetchSoapNotesFailure(errorMessage, requestType));
        }
    };
};

export const handleGenerateReport = ({ reqData, requestType, setRecommendationLetter, setSoapNotes }) => {
    return async (dispatch) => {
        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(pharmacy_generate_soap_notes, reqData);
            if (response.status === 200) {
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType));

                setRecommendationLetter(response?.data?.recommendation_letter || "")
                setSoapNotes(response?.data?.soap_note || "")


            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Got an issue while generating report.please try again", "error")
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};

export const handleSaveSoapNotes = ({ reqData, requestType }) => {
    return async (dispatch) => {
        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(pharmacy_save_soap_notes, reqData);
            if (response.status === 200) {
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType));
                const url = response?.data?.data?.pdfurl
                const result = await Axios.get(url)
                PreviewPdf(result?.data?.data)
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Got an issue while saving SOAP notes.please try again", "error")
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};

export const handleSendFaxSoapNote = ({ reqData, requestType }) => {
    return async (dispatch) => {
        const isConfirmed = await confirmSendFax();
        if (!isConfirmed) return;

        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(pharmacy_fax_soap_note, reqData);
            if (response.status === 200) {
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType));
                // const url = response?.data?.data
                // PreviewPdf(url)
                showToast("Fax sent successfully", "success")
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Got an issue while sending fax.please try again", "error")
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};

// Send Log Fax - for Med Review Log V2 page
export const handleSendLogFax = ({ reqData, requestType }) => {
    return async (dispatch) => {
        const isConfirmed = await confirmSendFax();
        if (!isConfirmed) return;

        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(pharmacy_send_log_fax, reqData);
            if (response.status === 200) {
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType));
                showToast("Fax sent successfully", "success")
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Got an issue while sending fax. Please try again", "error")
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};

export const handleFetchDoctorsFromWinRX = ({ requestType }) => {
    return async (dispatch) => {
        dispatch(addPatientSoapNotesDataRequest(requestType));
        try {
            const response = await Axios.post(pharmacy_fetch_doctors_from_winrx);
            if (response.status === 200) {
                showToast("List updated successfully", "success")
                dispatch(addPatientSoapNotesDataSuccess(response.data, requestType));
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            showToast("Got an issue while fetching doctors from WinRX.please try again", "error")
            dispatch(addPatientSoapNotesDataFailure(errorMessage, requestType));
        }
    };
};

const initialState = {
    patientSoapNotesData: {
        data: null,
        loading: false,
        error: null,
        fetchType: null
    },
    addedData: {
        data: null,
        loading: false,
        error: null,
        fetchType: null
    },
    createSoapNotes: {
        data: null,
        loading: false,
        error: null,
        fetchType: null
    }
};
// Reducer
const PatientSoapNotesReducer = (state = initialState, action) => {
    switch (action.type) {
        //PATIENT SOAP NOTES 
        case FETCH_PATIENT_SOAP_LIST_REQUEST:
            return {
                ...state,
                patientSoapNotesData: {
                    loading: true,
                    data: null,
                    error: null,
                    fetchType: action.payload.requestType
                }
            };
        case FETCH_PATIENT_SOAP_LIST_SUCCESS:
            return {
                ...state,
                patientSoapNotesData: {
                    loading: false,
                    error: null,
                    data: action.payload.data,
                    fetchType: action.payload.requestType
                }
            };
        case FETCH_PATIENT_SOAP_LIST_FAILURE:
            return {
                ...state,
                patientSoapNotesData: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    fetchType: action.payload.requestType
                }
            };

        case ADD_PATIENT_SOAP_NOTE_DATA_REQUEST:
            return {
                ...state,
                addedData: {
                    loading: true,
                    data: null,
                    error: null,
                    fetchType: action.payload.requestType
                }
            };
        case ADD_PATIENT_SOAP_NOTE_DATA_SUCCESS:
            return {
                ...state,
                addedData: {
                    loading: false,
                    error: null,
                    data: action.payload.data,
                    fetchType: action.payload.requestType
                }
            };
        case ADD_PATIENT_SOAP_NOTE_DATA_FAILURE:
            return {
                ...state,
                addedData: {
                    loading: false,
                    error: action.payload.data,
                    data: null,
                    fetchType: action.payload.requestType
                }
            };

        case FETCH_SOAP_NOTES_REQUEST:
            return {
                ...state,
                createSoapNotes: {
                    loading: true,
                    data: null,
                    error: null,
                    fetchType: action.payload.requestType
                }
            };
        case FETCH_SOAP_NOTES_SUCCESS:
            return {
                ...state,
                createSoapNotes: {
                    loading: false,
                    error: null,
                    data: action.payload.data,
                    fetchType: action.payload.requestType
                }
            };
        case FETCH_SOAP_NOTES_FAILURE:
            return {
                ...state,
                createSoapNotes: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    fetchType: action.payload.requestType
                }
            };
        default:
            return state;
    }
};

export default PatientSoapNotesReducer;
